import React, { Component } from "react";
import "./header.css";

export default class Appbar extends Component {
  render() {
    return <div className="navbar">
      {this.props.children}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/NavBar/Appbar.js